import React from 'react';
import { Hero } from './components/sections/Hero';
import { Testimonials } from './components/sections/Testimonials';
import { Problem } from './components/sections/Problem';
import { Tomos } from './components/sections/Tomos';
import { Bonos } from './components/sections/Bonos';
import { Offer } from './components/sections/Offer';
import { MoreTestimonials } from './components/sections/MoreTestimonials';
import { Guarantee } from './components/sections/Guarantee';
import { Faq } from './components/sections/Faq';
import { CostOfInaction } from './components/sections/CostOfInaction';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  return <div className="min-h-screen w-full bg-ink font-sans text-body" data-id="element-0" data-mp="28te198rqp1kz">
      <Hero data-id="element-1" data-mp="23vkw8j26adma" />
      <main data-id="element-2" data-mp="23vuoyeelqyvo">
        <Testimonials data-id="element-3" data-mp="23u9tmmkgrbwr" />
        <Problem data-id="element-4" data-mp="23ut9zyugts8o" />
        <Tomos data-id="element-5" data-mp="23t8gmcjw0fce" />
        <Bonos data-id="element-6" data-mp="3ijxnsm94vshs" />
        <Offer data-id="element-7" data-mp="3ikh7o8icgqyg" />
        <MoreTestimonials data-id="element-8" data-mp="3iiwdijzxza14" />
        <Guarantee data-id="element-9" data-mp="3ijftvw9y1qd1" />
        <Faq data-id="element-10" data-mp="3ii4su47vuwpm" />
        <CostOfInaction data-id="element-11" data-mp="3mlj8uuvtnd32" />
        <FinalCta data-id="element-12" data-mp="3mkrbpfmkt7ao" />
      </main>
      <Footer data-id="element-13" data-mp="3mjztd6hzp62c" />
      <PurchaseNotifications data-id="element-14" data-mp="3mjg8bgx1m1k3" />
    </div>;
}